import { selectAll } from 'd3-selection';

import { FixMe } from 'types';

export default (d: FixMe) =>
  selectAll('g[class^=blip] .shape').filter((elem: FixMe) => elem.id === d.id);
